(function() {
  function getNextMadeDate() {
    // All computation in London time, regardless of viewer's timezone
    var nowParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      hour12: false
    }).formatToParts(new Date());

    var partMap = {};
    nowParts.forEach(function(p) { partMap[p.type] = p.value; });

    var londonNow = new Date(Date.UTC(
      parseInt(partMap.year, 10),
      parseInt(partMap.month, 10) - 1,
      parseInt(partMap.day, 10),
      parseInt(partMap.hour, 10)
    ));

    var londonHour = parseInt(partMap.hour, 10);
    // weekday short → JS day index: Sun=0, Mon=1 ... Sat=6
    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var londonDay = weekdayMap[partMap.weekday];

    // Days until next Thursday (4). If today IS Thursday, it's 7 (next week's).
    var daysUntilThursday = (4 - londonDay + 7) % 7;
    if (daysUntilThursday === 0) daysUntilThursday = 7;

    // BUT: if today is before Wed 8am, this week's Thursday is still in scope
    // i.e. on Mon, Tue, or Wed (before 8am), made date = this Thursday
    if (londonDay === 1 || londonDay === 2) {
      daysUntilThursday = 4 - londonDay; // Mon→3, Tue→2
    } else if (londonDay === 3 && londonHour < 8) {
      daysUntilThursday = 1; // Wed before 8am → tomorrow
    } else if (londonDay === 3) {
      daysUntilThursday = 8; // Wed 8am+ → next Thursday
    } else if (londonDay === 4) {
      daysUntilThursday = 7; // Thu → next Thu
    } else if (londonDay === 5) {
      daysUntilThursday = 6; // Fri → next Thu
    } else if (londonDay === 6) {
      daysUntilThursday = 5; // Sat → next Thu
    } else if (londonDay === 0) {
      daysUntilThursday = 4; // Sun → this Thu
    }

    // Build the target date and format it in London time
    var targetUTC = new Date(londonNow.getTime() + daysUntilThursday * 24 * 60 * 60 * 1000);
    var formatted = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      weekday: 'short',
      day: 'numeric'
    }).format(targetUTC);

    // "Thu 21" → "THU 21"
    return formatted.toUpperCase();
  }

  function updateMadeToOrderLabels() {
    var els = document.querySelectorAll('.js-made-to-order-date');
    for (var i = 0; i < els.length; i++) {
      var override = els[i].getAttribute('data-override');
      els[i].textContent = override || getNextMadeDate();
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMadeToOrderLabels);
  } else {
    updateMadeToOrderLabels();
  }

  // Re-run every minute so the label stays correct if the page is left open
  // across the Wednesday 8am cutoff
  setInterval(updateMadeToOrderLabels, 60 * 1000);
})();

$(window).ready(function(){
  $(".slick-slide .single-image.fullscreen-slider-img").parent().parent().addClass('hasclass');
});

$(window).ready(function(){
  setInterval(function(){ 
    $('.subscribe-section').addClass("slide-in")
  }, 2500);
  
  setInterval(function(){ 
    $('.subscribe-section').addClass("slide-in-cancel")
  }, 3000);

});
 
$(window).scroll(function(){ 
    if ($(this).scrollTop() > 2) { 
       $('.additional-info-links p').removeClass('selected');  
    } 
});   

  
let elementsArray = document.querySelectorAll(".tile");
console.log(elementsArray);
window.addEventListener('scroll', fadeIn );     
function fadeIn() {  
    for (var i = 0; i < elementsArray.length; i++) {  
        var elem = elementsArray[i]
        var distInView = elem.getBoundingClientRect().top - window.innerHeight + 20;
        if (distInView < 0) {
            elem.classList.add("inView");
        } else {
            elem.classList.remove("inView");  
        }          
    }     
}  


fadeIn();



$.fn.visible = function(partial) {

  var $t = $(this),
    $w = $(window),
    viewTop = $w.scrollTop(),
    viewBottom = viewTop + $w.height(),
    _top = $t.offset().top,
    _bottom = _top + $t.height(),
    compareTop = partial === true ? _top : _bottom,
    compareBottom = partial === true ? _bottom : _top;

  return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
}

$(document).ready(function(e) {
  checkVisible();
});

$(window).scroll(function(e) {
  checkVisible();
});


function checkVisible() {
  $('.content-wrap.timeline').each(function(i, k) {
    if ($(this).visible()) {
      $('.made-this-label p').addClass('');
    } else {
      $('.made-this-label p').removeClass('');
    }
  });
}





$(document).ready(function () {

  $('.item-detail-slider ul li:first-child').addClass('is-selected');

  const utils = window.fizzyUIUtils;
  
const flkty = new Flickity(".main-carousel", {
  fade: true,
  hash: true,
  draggable: true,
  wrapAround: true,
  prevNextButtons: true
});

const rightArrow = '<svg viewBox="0 0 57.039 112.666" xmlns="http://www.w3.org/2000/svg" width="12" height="28"><polygon fill="#21213c" stroke="#21213c" stroke-width="1" points=".707 112.666 0 111.959 55.625 56.333 0 .707 .707 0 57.039 56.333 .707 112.666"/></svg>';

const leftArrow = '<svg viewBox="0 0 56.333 112.666" xmlns="http://www.w3.org/2000/svg" width="12" height="28"><polygon fill="#21213c" stroke="#21213c" stroke-width="1" points="56.333 112.666 0 56.333 56.333 0 57.04 .707 1.414 56.333 57.04 111.959 56.333 112.666"/></svg>';

document.querySelector('.main-carousel .flickity-prev-next-button.next').innerHTML = rightArrow;
document.querySelector('.main-carousel .flickity-prev-next-button.previous').innerHTML = leftArrow;

const carouselButtonGroup = document.querySelector(".carousel__buttons");
const carouselButtons = utils.makeArray(carouselButtonGroup.children);

// update buttons on select
flkty.on( 'select', function() {
  const previousSelectedButton = carouselButtonGroup.querySelector('.is-selected');
  const selectedButton = carouselButtonGroup.children[ flkty.selectedIndex ];
  previousSelectedButton.classList.remove('is-selected');
  selectedButton.classList.add('is-selected');
});

carouselButtonGroup.addEventListener("click", function (event) {
  // Filter for button clicks
  if (!matchesSelector(event.target, ".button")) {
    return;
  }
  const selector = event.target.getAttribute("data-selector");
  // const index = carouselButtons.indexOf( event.target );
  // flkty.select( index );
  flkty.selectCell(selector);
});

// Previous button
const previousButton = document.querySelector(".button--previous");
previousButton.addEventListener("click", function () {
  flkty.previous();
});

// Next button
const nextButton = document.querySelector(".button--next");
nextButton.addEventListener("click", function () {
  flkty.next();
});

});



$(document).ready(function () {

  
  

  $('label:contains("(sold out)")').each(function () {
    $(this).html($(this).html().split("(sold out)").join(""));
  });
 
  $('#select-option1').on('change',function(){
        var value = $(this).val();
        var content = $('.color-block-mobile') 
        content.removeClass().addClass('color-block-mobile '+value.toLowerCase())
    })
  

});




$(document).ready(function () {
  
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;  
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 
  

$('.slider.single_img').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.slider-nav-thumbnails',
  fade: true,
  responsive: [
        {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
        }
  ]
 });

$('.slider.triple_img').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.slider-nav-thumbnails',
  responsive: [
        {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              fade: true
            }
        }
  ]
});



$('.image-counter .slider-nav-thumbnails').slick({
 	slidesToShow: 5,
 	slidesToScroll: 1,
 	asNavFor: '.slides.js-slides.slider:not(.enlarged)',
 	dots: true,
 	focusOnSelect: true
 });

var enlargedFlickity = null;
var enlargedNavFlickity = null;

function initEnlargedFlickity() {
  // Helper: get current main gallery index, normalised
  function getMainIndex() {
  var mainFlkty = Flickity.data('.gallery');
  if (!mainFlkty || !mainFlkty.cells || mainFlkty.cells.length === 0) return 0;
  return mainFlkty.selectedIndex % mainFlkty.cells.length;
}

  // If already initialised, just sync to main gallery's current slide and bail
  if (enlargedFlickity) {
    enlargedFlickity.select(getMainIndex(), false, true);
    if (enlargedNavFlickity) enlargedNavFlickity.select(getMainIndex(), false, true);
    return;
  }

var mainIndex = getMainIndex();

  enlargedFlickity = new Flickity('.enlarged-gallery', {
    cellAlign: 'left',
    wrapAround: true,
    pageDots: false,
    contain: true,
    draggable: true,
    prevNextButtons: true,
    selectedAttraction: 0.025,
    friction: 0.28,
    initialIndex: mainIndex
  });

  if ($('.enlarged-gallery-nav').length) {
    enlargedNavFlickity = new Flickity('.enlarged-gallery-nav', {
      cellAlign: 'left',
      asNavFor: '.enlarged-gallery',
      contain: true,
      pageDots: false,
      draggable: false,
      prevNextButtons: false
    });
  }

  // Match the main gallery's custom arrow SVGs
  var rightArrow = '<svg viewBox="0 0 57.039 112.666" xmlns="http://www.w3.org/2000/svg" width="12" height="28"><polygon fill="#21213c" stroke="#21213c" stroke-width="1" points=".707 112.666 0 111.959 55.625 56.333 0 .707 .707 0 57.039 56.333 .707 112.666"/></svg>';
  var leftArrow = '<svg viewBox="0 0 56.333 112.666" xmlns="http://www.w3.org/2000/svg" width="12" height="28"><polygon fill="#21213c" stroke="#21213c" stroke-width="1" points="56.333 112.666 0 56.333 56.333 0 57.04 .707 1.414 56.333 57.04 111.959 56.333 112.666"/></svg>';
  var nextBtn = document.querySelector('.enlarged-gallery .flickity-prev-next-button.next');
  var prevBtn = document.querySelector('.enlarged-gallery .flickity-prev-next-button.previous');
if (nextBtn) nextBtn.innerHTML = rightArrow;
  if (prevBtn) prevBtn.innerHTML = leftArrow;

// Update the dedicated enlarged-view counter on slide change
  var counterCurrent = document.querySelector('.enlarged-counter-current');

  function updateEnlargedCounter() {
    if (!counterCurrent || !enlargedFlickity) return;
    var totalSlides = enlargedFlickity.cells ? enlargedFlickity.cells.length : 0;
    if (totalSlides === 0) return;
    var idx = enlargedFlickity.selectedIndex;
    if (typeof idx !== 'number' || isNaN(idx)) idx = 0;
    var slideNumber = (idx % totalSlides) + 1;
    counterCurrent.textContent = slideNumber;
  }

  enlargedFlickity.on('select', updateEnlargedCounter);
  enlargedFlickity.on('change', updateEnlargedCounter);
  updateEnlargedCounter();
}
$(".product-slider-enlarge").on('click', function() {
  setTimeout(function() {
    if ($('.enlarged-slider-main').hasClass('display-fullscreen') || $('#page-product').hasClass('slider-enlarged')) {
      // Hide gallery contents during init/jump to prevent flash of slide 1
      $('.enlarged-gallery').css('visibility', 'hidden');
      
      initEnlargedFlickity();
      if (enlargedFlickity) enlargedFlickity.resize();
      if (enlargedNavFlickity) enlargedNavFlickity.resize();

      // Reveal on next frame, after Flickity has settled at the target index
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          $('.enlarged-gallery').css('visibility', 'visible');
        });
      });
    }
  }, 100);
});

 // Remove active class from all thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

 // Set active class to first thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

 // On before slide change match active thumbnail to current slide
 $('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
 	var mySlideNumber = nextSlide;
 	$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
 	$('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
 });
  
  
jQuery(document).ready(function($) {
  var alterClass = function() {
    var ww = document.body.clientWidth;
    if (ww < 600) {
      $('body').addClass('mobile-window');
    } else if (ww >= 601) {
      $('body').removeClass('mobile-window');
    };
  };
  $(window).resize(function(){
    alterClass();
  });
  //Fire it when the page first loads:
  alterClass();
});

  
$(".OAUShop .header-nav-list li:first-child, .all .header-nav-list li:first-child").click(function(){
  $(".product-filter").toggleClass("filter-hidden");
  $(this).toggleClass("minus-symbol");
});

$(".header-left.mobile").click(function(){
  $(".mobile-nav-dropdown, .mobile-nav").toggleClass("nav-menu-open");
  $("html").removeClass("mini-cart-open");
  $("body").toggleClass("mobile-menu-open");
});

  $(".news-link, .ticker-cross").click(function(){
  $("#tickerListWrapper").toggleClass("ticker-display");
  $("#footer-global").toggleClass("footer-ticker-display");
  $(".news-link").toggleClass("tint");
  $(".cookies-section").toggleClass("ticker-active"); 
    $("body").toggleClass("extended-footer-2"); 
    $(".subscribe-section").toggleClass("subscribe-section-ticker-on"); 
    subscribe-section-ticker-on
});

  $(".footer-section .text_block").click(function(){
  $(this).toggleClass("footer-section-open");
}); 

    $(".toggle").click(function(){
  $(this).toggleClass("toggle-open");
}); 
 
 
$(".cookies-section").click(function(){
  $(this).addClass("hide-ticker-2");
  $("body").removeClass("extended-footer-1"); 
  $(".subscribe-section").addClass("hide-ticker-2");
  $(".footer-inner").addClass("no-padding");
  
}); 

  $(".page-2").click(function(){
  
}); 



  

$(".subscribe-module-close").click(function(){
  $(".subscribe-section").addClass("hide-subscribe-module");
  $(".template-index .footer-inner").addClass("shrink-footer");
}); 

$("#how-we-made-this .content-block-header_1").click(function(){
  $("#how-we-made-this").toggleClass("product-info-open");
});
  
$(".things-to-know-container .content-block-header_1").click(function(){
  $(".things-to-know-container").toggleClass("product-info-open");
});

$(".item-care .content-block-header_1").click(function(){
  $(".item-care").toggleClass("product-info-open");
});

$(".shipping-and-returns .content-block-header_1").click(function(){
  $(".shipping-and-returns").toggleClass("product-info-open");
});

$("#sizing-guide .additional-info-header_1").click(function(){
  $("#sizing-guide").toggleClass("product-info-open");
  $('.hero-slideshow').toggleClass("sizing-guide-open");
});




  $(window).ready(function(){
  setInterval(function(){ 
    $('.homepage-overlay').addClass("visible-full")
  }, 1500);

});

  
  
  $(".OAUShop .header-nav-list li a, .all .header-nav-list li a").click(function(){
  $(".product-filter").removeClass("filter-hidden");
});

    $(".welcome-messages .subscribe-submit-modal .modal-cross").click(function(){
  $(".subscribe-modal, .subscribe-submit-modal").addClass("close-modal-section");
});

$(".additional-info-links p").click(function(){
  $(this).addClass("selected");
  $('.additional-info-links p').not(this).removeClass("selected");
});

  

      $(".welcome-messages .accept-modal .modal-cross, .accept-modal").click(function(){
  $(".subscribe-modal, .cookies-modal, .accept-modal, .subscribe-submit-modal").addClass("close-modal-section");
        
});
  
  
  
  $("#filter-tags a, .text-link").click(function(){
    $(".product-filter").addClass("filter-hidden");
    $(".OAUShop .header-nav-list li:first-child, .all .header-nav-list li:first-child").removeClass("minus-symbol");
  
});
  
  $(".triple_img-wrapper .product-slider-enlarge").click(function(){
  $(".enlarged-slider-main").toggleClass("display-fullscreen");
    $("body").toggleClass("slider-enlarged-body");
    $("#tickerListWrapper").removeClass("ticker-display");
  });

  $(".single_img-wrapper .product-slider-enlarge").click(function(){
    $("#page-product").toggleClass("slider-enlarged");
    $("body").toggleClass("slider-enlarged-body");
    $("#tickerListWrapper").removeClass("ticker-display");
  });

  $(".product-title").click(function(){
  $(".product-actions").removeClass("item-added-to-cart");
  });

  $("#tickerListWrapper .modal-cross").click(function(){
  $('#tickerListWrapper').addClass("hide-ticker");
  });
  
$(window).ready(function(){
  setInterval(function(){ 
    $('#splash-logo').addClass("fade-out-logo")
  }, 1500);

  setInterval(function(){ 
    $('#splash-logo').addClass("fade-out-logo-hide")
  }, 2300);

});
  
  (function ($) {
    var $tickerList = $('.ticker__list'),
        $tickerListWrapper = $('#tickerListWrapper'),
        tickerListWidth = $tickerList.width();

    if (tickerListWidth > $tickerListWrapper.width()) {
        $tickerList.css('animation-duration', tickerListWidth/55 + 's');
        $tickerList.addClass('animation');
      $tickerList.clone().appendTo($tickerListWrapper);
 
    }

})(jQuery);
  

  // Add to Cart Form
  let
    addToCartFormSelector = '#add-to-cart-form',
    productOptionSelector = addToCartFormSelector + ' [name*=option]';

  let productForm = {
    onProductOptionChanged: function(event) {
      let
        $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      $form.trigger('form:change', [selectedVariant]);
    },
    getActiveVariant: function($form) {
      let
        variants = JSON.parse(decodeURIComponent($form.attr('data-variants'))),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null
        },
        selectedVariant = null;

      $.each(formData, function(index, item) {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      $.each(variants, function(index, variant) {
        if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
          selectedVariant = variant;
          return false;
        }
      });

      return selectedVariant;

    },
    validate: function(event, selectedVariant) {
      let
        $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find('.js-variant-id'),
        $addToCartButton = $form.find('#add-to-cart-button'),
        $price = $form.find('.js-price'),
        formattedVariantPrice,
        priceHtml;

      if (hasVariant) {
        formattedVariantPrice = '$' + (selectedVariant.price/100).toFixed(2);
        priceHtml = '<span class="money">'+formattedVariantPrice+'</span>';
        window.history.replaceState(null, null, '?variant='+selectedVariant.id);
      }
      else {
        priceHtml = $price.attr('data-default-price');
      }

      if (canAddToCart) {
        $id.val(selectedVariant.id);
        $addToCartButton.prop('disabled', false);
      }
      else {
        $id.val('');
        $addToCartButton.prop('disabled', true);
      }

    },
    init: function() {
      $(document).on('change', productOptionSelector, productForm.onProductOptionChanged);
      $(document).on('form:change', addToCartFormSelector, productForm.validate);
    }
  };

  productForm.init();

  // Ajax API Functionality
  let miniCartContentsSelector = '.js-mini-cart-contents';
  let ajaxify = {
    onAddToCart: function(event) {
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: ajaxify.onCartUpdated,
        error: ajaxify.onError
      });
    },
    onCartUpdated: function() {
      let
        $miniCartFieldset = $(miniCartContentsSelector + ' .js-cart-fieldset');

      $miniCartFieldset.prop('disabled', true);

      $.ajax({
        type: 'GET',
        url: '/cart',
        context: document.body,
        success: function(context) {
          let
            $dataCartContents = $(context).find('.js-cart-page-contents'),
            dataCartHtml = $dataCartContents.html(),
            dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
            $miniCartContents = $(miniCartContentsSelector),
            $cartItemCount = $('.js-cart-item-count');

          $cartItemCount.text(dataCartItemCount);
          $miniCartContents.html(dataCartHtml);
  

          if (parseInt(dataCartItemCount) > 0) {
            

            $('.js-cart-link')
              .addClass('cart-full')
            
            $('.product-actions')
        .addClass('item-added-to-cart');
            
            setTimeout(function(){ 
              $('.product-actions').removeClass("item-added-to-cart");
            }, 3000); 
        

          }
          else {
            ajaxify.closeCart();
            $('.js-cart-link')
              .removeClass('cart-full');
            
            
          }
        }
      });
    },
    onError: function(XMLHttpRequest, textStatus) {
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + ' - ' + data.message + ': ' + data.description);
    },
    onCartButtonClick: function(event) {
      let
        isCartOpen = $('html').hasClass('mini-cart-open'),
        isInCart = window.location.href.indexOf('/cart') !== -1;

      if (!isInCart) {
        event.preventDefault();
        if (!isCartOpen) {
          ajaxify.openCart();
        }
        else {
          ajaxify.closeCart();
        }
      }
    },
    openCart: function() {
      $('html').addClass('mini-cart-open');
    },
    closeCart: function() {
      $('html').removeClass('mini-cart-open');
    },
    init: function() {
      $(document).on('submit', addToCartFormSelector, ajaxify.onAddToCart);

      $(document).on('click', '.js-cart-link, .js-keep-shopping, #no-click', ajaxify.onCartButtonClick);
    }
  };

  ajaxify.init();


  // Quantity Fields
  let
    quantityFieldSelector = '.js-quantity-field',
    quantityButtonSelector = '.js-quantity-button',
    quantityPickerSelector = '.js-quantity-picker',
    quantityPicker = {
      onButtonClick: function(event) {
        // alert('button clicked');
        let
          $button = $(this),
          $picker = $button.closest(quantityPickerSelector),
          $quantity = $picker.find('.js-quantity-field'),
          quantityValue = parseInt($quantity.val()),
          max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;

        if ($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
          // do something for plus click
          $quantity.val(quantityValue + 1).change();
        }
        else if ($button.hasClass('minus')) {
          // do something for minus click
          $quantity.val(quantityValue - 1).change();
        }
      },
      onChange: function(event) {
        let
          $field = $(this),
          $picker = $field.closest(quantityPickerSelector),
          $quantityText = $picker.find('.js-quantity-text'),
          shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
          shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
          $minusButton = $picker.find('.js-quantity-button.minus'),
          $plusButton = $picker.find('.js-quantity-button.plus');

        $quantityText.text(this.value);

        if (shouldDisableMinus) {
          $minusButton.prop('disabled', true);
        }
        else if ($minusButton.prop('disabled') === true) {
          $minusButton.prop('disabled', false);
        }

        if (shouldDisablePlus) {
          $plusButton.prop('disabled', true);
        }
        else if ($plusButton.prop('disabled') === true) {
          $plusButton.prop('disabled', false);
        }
      },
      init: function() {
        $(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
        $(document).on('change', quantityFieldSelector, quantityPicker.onChange);
      }
    };

  quantityPicker.init()



  // Line Item
  let
    removeLineSelector = '.js-remove-line',
    lineQuantitySelector = '.js-line-quantity';

  let lineItem = {
    isInMiniCart: function(element) {
      let
        $element = $(element),
        $miniCart = $element.closest(miniCartContentsSelector),
        isInMiniCart = $miniCart.length !== 0;

      return isInMiniCart;
    },
    onLineQuantityChanged: function(event) {
      let
        quantity = this.value,
        id = $(this).attr('id').replace('updates_', ''),
        changes = {
          quantity: quantity,
          id: id
        },
        isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        $.post('/cart/change.js', changes, ajaxify.onCartUpdated, 'json');
      }
    },
    onLineRemoved: function(event) {
      let isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        event.preventDefault();
        
        let
          $removeLink = $(this),
          removeQuery = $removeLink.attr('href').split('change?')[1];
        $.post('/cart/change.js', removeQuery, ajaxify.onCartUpdated, 'json');
      }
    },
    init: function() {
      $(document).on('click', removeLineSelector, lineItem.onLineRemoved);
      $(document).on('change', lineQuantitySelector, lineItem.onLineQuantityChanged);
    }
  };

  lineItem.init();

  // Search Input
  let
    searchInputSelector = '.js-search-input',
    searchSubmitSelector = '.js-search-submit',
    onSearchInputKeyup = function(event) {
      let
        $form = $(this).closest('form'),
        $button = $form.find(searchSubmitSelector),
        shouldDisableButton = this.value.length === 0;

      $button.prop('disabled', shouldDisableButton);

    };

    $(document).on('keyup', searchInputSelector, onSearchInputKeyup);

  // Slideshows
  let
    slidesSelector = '.js-slides',
    prevButtonSelector = '.js-slider-button-prev',
    nextButtonSelector = '.js-slider-button-next';

  // Product
  let
    productSlideshowSelector = '.js-product-slideshow',
    currentSlideSelector = '.js-current-slide',
    productSlideshows = {
      onBeforeChange: function(event, slick, currentSlide, nextSlide) {
        let $currentSlide = slick.$slider.closest(productSlideshowSelector).find(currentSlideSelector);

        $currentSlide.text(nextSlide+1);
      },
      setup: function($element) {
        let  
          $slides = $element.find(slidesSelector),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          productSlideshowOptions = {
            fade: true,
            nextArrow: $nextButton,
            prevArrow: $prevButton
          };

        if ($slides.children().length > 1) {
          $slides.on('beforeChange', productSlideshows.onBeforeChange).slick(productSlideshowOptions);
        }
      },
      init: function () {
        $(productSlideshowSelector).each(function() {
          productSlideshows.setup($(this));
        });
      }
    };

  productSlideshows.init();

  // Section Slideshow
  let
    sectionSlideshowSelector = '.js-section-slideshow',
    sectionSlideshows = {
      setup: function($element) {
        let
          $slides = $element.find(slidesSelector),
          shouldAutoplay = $element.attr('data-autoplay') === 'true',
          autoplaySpeed = parseInt($element.attr('data-autoplay-speed')),
          $prevButton = $element.find(prevButtonSelector),
          $nextButton = $element.find(nextButtonSelector),
          sectionSlideshowOptions = {
            fade: true,
            nextArrow: $nextButton,
            prevArrow: $prevButton,
            autoplay: shouldAutoplay,
            autoplaySpeed: autoplaySpeed
          };

        if ($slides.children().length > 1) {
          $slides.slick(sectionSlideshowOptions);
        }
      },
      init: function() {
        $(sectionSlideshowSelector).each(function() {
          sectionSlideshows.setup($(this));
        });
      }
    };

  sectionSlideshows.init();

});

// =============================================================================
// REPLACEMENT for the entire `window.addEventListener('load', function () { ... })`
// block at the bottom of theme.js (the one starting with `var FirstAvailable =`).
//
// Replaces the hardcoded 2-option logic with n-dimensional logic that handles
// 1, 2, or 3 options. Behaviour for 2-option products is unchanged.
// =============================================================================

window.addEventListener('load', function () {

    var $form = $('#add-to-cart-form');
    if (!$form.length) return;

    var variants = JSON.parse(decodeURIComponent($form.attr('data-variants')));
    var isReconciling = false; // re-entry guard

    // --- Helpers --------------------------------------------------------------

    function getCurrentSelection() {
        var selection = {};
        $('.desktop-add-to-cart .option-values').each(function () {
            var index = $(this).data('index');
            var $checked = $(this).find('input[type="radio"]:checked');
            if ($checked.length) {
                selection[index] = $checked.val();
            }
        });
        // Fall back to mobile selects for any option not found via radios
        $('.mobile-add-to-cart .option-values').each(function () {
            var index = $(this).data('index');
            if (selection[index]) return;
            var $select = $(this).find('select');
            if ($select.length && $select.val() && $select.val() !== 'placeholder') {
                selection[index] = $select.val();
            }
        });
        return selection;
    }

    // For a given option index, return values that are available given the
    // OTHER currently-selected options.
    function getAvailableValuesForOption(optionIndex, selection) {
        var available = [];
        $.each(variants, function (i, variant) {
            if (!variant.available) return;
            var matchesOthers = true;
            for (var key in selection) {
                if (parseInt(key) === parseInt(optionIndex)) continue;
                if (variant['option' + key] !== selection[key]) {
                    matchesOthers = false;
                    break;
                }
            }
            if (matchesOthers) {
                var val = variant['option' + optionIndex];
                if (available.indexOf(val) === -1) available.push(val);
            }
        });
        return available;
    }

    function applyAvailability(optionIndex, availableValues) {
        var $rows = $('.option-values[data-index="' + optionIndex + '"]');

        $rows.find('input[type="radio"]').each(function () {
            $(this).prop('disabled', availableValues.indexOf($(this).val()) === -1);
        });

        $rows.find('select option').each(function () {
            var val = $(this).val();
            if (val === 'placeholder') return;
            $(this).prop('disabled', availableValues.indexOf(val) === -1);
        });

        $rows.find('.dropdown-option').each(function () {
            var val = $(this).data('value');
            var isAvailable = availableValues.indexOf(val) !== -1;
            $(this).attr('data-available', isAvailable);
            if (isAvailable) {
                $(this).removeClass('disabled');
                $(this).find('.option-text').removeClass('sold-out');
            } else {
                $(this).addClass('disabled');
                $(this).find('.option-text').addClass('sold-out');
            }
        });

        if (availableValues.length === 0) {
            $rows.find('select').css('opacity', '0');
            $rows.find('#custom-select-soldout').show();
        } else {
            $rows.find('select').css('opacity', '1');
            $rows.find('#custom-select-soldout').hide();
        }
    }

    // Quietly update a radio + its mobile select counterpart WITHOUT firing
    // change events (we manage cascading manually to avoid re-entry).
    function setSelectionQuiet(optionIndex, value) {
        var $rows = $('.option-values[data-index="' + optionIndex + '"]');

        // Radio
        $rows.find('input[type="radio"]').prop('checked', false);
        $rows.find('input[type="radio"][value="' + value + '"]').prop('checked', true);

        // Native select (no .change(), no events)
        $rows.find('select').val(value);

        // Custom dropdown UI
        var $opts = $rows.find('.dropdown-option');
        if ($opts.length) {
            $opts.removeClass('selected');
            $opts.filter('[data-value="' + value + '"]').addClass('selected');
            // Update trigger text
            var $trigger = $rows.closest('.custom-dropdown').find('.dropdown-trigger');
            var triggerText = $opts.filter('[data-value="' + value + '"]')
                                   .find('.option-text').text().replace(' (SOLD OUT)', '');
            $trigger.find('.selected-text').text(triggerText);
console.log('setSelectionQuiet wrote FLAT text:', triggerText, 'to', $trigger[0]);
            $trigger.removeClass('placeholder');
        }
    }

    // After a user picks something in `changedIndex`, recalculate availability
    // for all OTHER options. If an other option's current value is no longer
    // available, fall it to the first available value. Repeat until stable
    // (handles cascading 3-option case).
    function cascadeFrom(changedIndex) {
        if (isReconciling) return;
        isReconciling = true;

        try {
            var totalOptions = $('.desktop-add-to-cart .option-values').length;
            var maxPasses = 5; // safety
            var pass = 0;
            var changed = true;

            while (changed && pass < maxPasses) {
                changed = false;
                pass++;
                var selection = getCurrentSelection();

                for (var i = 1; i <= totalOptions; i++) {
                    if (i === parseInt(changedIndex)) continue;
                    var available = getAvailableValuesForOption(i, selection);
                    var current = selection[i];

                    if (available.length > 0 && available.indexOf(current) === -1) {
                        setSelectionQuiet(i, available[0]);
                        changed = true;
                    }
                }
            }

            // Final pass: apply visual availability to all non-changed options
            // based on the final stable selection.
            var finalSelection = getCurrentSelection();
            for (var j = 1; j <= totalOptions; j++) {
                if (j === parseInt(changedIndex)) continue;
                applyAvailability(j, getAvailableValuesForOption(j, finalSelection));
            }

            // Fire one synthetic change on the variant id so Shopify's
            // existing form:change validation runs and updates price / button.
            // We trigger change on the option that the user actually changed
            // so productForm.onProductOptionChanged picks up the new variant.
            $form.trigger('form:change', [getActiveVariant()]);
        } finally {
            isReconciling = false;
        }
    }

    function getActiveVariant() {
        var selection = getCurrentSelection();
        var match = null;
        $.each(variants, function (i, variant) {
            var ok = true;
            for (var k in selection) {
                if (variant['option' + k] !== selection[k]) { ok = false; break; }
            }
            if (ok) { match = variant; return false; }
        });
        return match;
    }

    // --- Wire-up --------------------------------------------------------------

    $(document).on('change', '.desktop-add-to-cart .option-values input[type="radio"]', function () {
        if (isReconciling) return;
        var changedIndex = $(this).closest('.option-values').data('index');
        // Sync mobile select to match desktop radio choice
        $('.mobile-add-to-cart .option-values[data-index="' + changedIndex + '"]')
            .find('select').val($(this).val());
        cascadeFrom(changedIndex);
    });

    $(document).on('change', '.mobile-add-to-cart .option-values select', function () {
        if (isReconciling) return;
        var changedIndex = $(this).closest('.option-values').data('index');
        // Sync desktop radio to match mobile select choice
        var $radio = $('.desktop-add-to-cart .option-values[data-index="' + changedIndex + '"]')
            .find('input[type="radio"][value="' + $(this).val() + '"]');
        if ($radio.length) {
            $('.desktop-add-to-cart .option-values[data-index="' + changedIndex + '"]')
                .find('input[type="radio"]').prop('checked', false);
            $radio.prop('checked', true);
        }
        cascadeFrom(changedIndex);
    });

    // --- Initial state --------------------------------------------------------

    setTimeout(function () {
        // Check if URL has ?variant= — if so, select that variant's options
        var urlParams = new URLSearchParams(window.location.search);
        var urlVariantId = urlParams.get('variant');
        var initialVariant = null;

        if (urlVariantId) {
            for (var i = 0; i < variants.length; i++) {
                if (String(variants[i].id) === String(urlVariantId)) {
                    initialVariant = variants[i];
                    break;
                }
            }
        }

        if (initialVariant) {
            // Select each option that matches the URL variant
            $('.desktop-add-to-cart .option-values').each(function () {
                var index = $(this).data('index');
                var valueToSelect = initialVariant['option' + index];
                if (valueToSelect) {
                    $(this).find('input[type="radio"][value="' + valueToSelect + '"]')
                        .prop('checked', true);
                }
            });
        } else {
            // Fallback: click the first available variant on each option
            $('.desktop-add-to-cart .option-values').each(function () {
                var $available = $(this).find('input.avalaible-variant');
                if ($available.length) $available.first().prop('checked', true);
            });
        }

        // Sync mobile selects to match desktop radios
        $('.desktop-add-to-cart .option-values').each(function () {
            var index = $(this).data('index');
            var $checked = $(this).find('input[type="radio"]:checked');
            if ($checked.length) {
                $('.mobile-add-to-cart .option-values[data-index="' + index + '"]')
                    .find('select').val($checked.val());
            }
        });

        // Run an initial cascade so availability reflects the starting state
        cascadeFrom(1);
    }, 500);
});

class CustomDropdown {
    constructor(container) {
        this.container = container;
        this.select = container.querySelector('select');
        this.trigger = container.querySelector('.dropdown-trigger');
        this.panel = container.querySelector('.dropdown-panel');
        this.backdrop = container.querySelector('.dropdown-backdrop');
        this.options = container.querySelectorAll('.dropdown-option');
        this.selectedText = this.trigger.querySelector('.selected-text');
        this.colorBlock = container.querySelector('.color-block-mobile');
        this.isOpen = false;
        this.isFirstOption = container.closest('[data-index="1"]') !== null;

        this.init();
    }

    init() {
        // Use pointerup for instant, reliable touch response (no 300ms click delay,
        // no dropped synthetic clicks when layout shifts).
        this.trigger.addEventListener('pointerup', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggle(e);
        });

        this.options.forEach(option => {
            option.addEventListener('pointerup', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.selectOption(e);
            });
        });

        if (this.backdrop) {
            this.backdrop.addEventListener('pointerup', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        // Outside-click fallback (use pointerdown so it settles before any click)
        document.addEventListener('pointerdown', (e) => this.handleOutsideClick(e));

        this.initializeOptionColors();

        if (this.isFirstOption && window.innerWidth < 768) {
            this.enableAllOptions();
        }

        this.syncFromSelect();

        if (this.select) {
            this.select.addEventListener('change', (e) => {
                if (!e.isTrusted) return;
                this.syncFromSelect();
            });
        }
    }

    enableAllOptions() {
        this.options.forEach(option => {
            option.classList.remove('disabled');
            const t = option.querySelector('.option-text');
            if (t) t.classList.remove('sold-out');
            option.dataset.available = 'true';
        });
    }

    initializeOptionColors() {
        this.options.forEach(option => {
            const colorBlock = option.querySelector('.option-color-block');
            const value = option.dataset.value;
            if (colorBlock) this.setColorBlock(colorBlock, value);
        });
    }

    toggle(e) {
        this.isOpen ? this.close() : this.open();
    }

    open() {
        // Close other open dropdowns
        document.querySelectorAll('.custom-dropdown .dropdown-panel.open').forEach(panel => {
            if (panel !== this.panel) {
                const otherContainer = panel.closest('.custom-dropdown');
                const otherBackdrop = otherContainer.querySelector('.dropdown-backdrop');
                panel.classList.remove('open');
                if (otherBackdrop) otherBackdrop.classList.remove('open');
                otherContainer.querySelector('.dropdown-trigger').classList.remove('active');
            }
        });

        this.isOpen = true;
        this.trigger.classList.add('active');
        this.panel.classList.add('open');
        if (this.backdrop) this.backdrop.classList.add('open');

        document.body.style.overflow = 'hidden';
        // NOTE: removed the sibling z-index/position hack — the panel and backdrop
        // already sit at z-index 10000000 via CSS, so siblings can't overlap them,
        // and mutating sibling layout was eating taps.
    }

    close() {
        this.isOpen = false;
        this.trigger.classList.remove('active');
        this.panel.classList.remove('open');
        if (this.backdrop) this.backdrop.classList.remove('open');
        document.body.style.overflow = '';
    }

    selectOption(e) {
        const option = e.currentTarget;

        if (this.isFirstOption && window.innerWidth < 768) {
            // allow selecting any colour
        } else if (option.classList.contains('disabled')) {
            return;
        }

        const value = option.dataset.value;
        const text = option.querySelector('.option-text').textContent.replace(' (SOLD OUT)', '');

        this.options.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');

        this.selectedText.textContent = text;
        this.trigger.classList.remove('placeholder');

        this.updateColorBlock(value);

        if (this.select) {
            this.select.value = value;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.close();
    }

    setColorBlock(colorBlock, value) {
        if (colorBlock.style.backgroundColor && colorBlock.style.backgroundColor !== '') return;

        const colorMap = {
            'Red': '#ff0000', 'Blue': '#0000ff', 'Green': '#00ff00', 'Black': '#000000',
            'White': '#ffffff', 'Navy': '#000080', 'Gray': '#808080', 'Grey': '#808080',
            'Pink': '#ffc0cb', 'Yellow': '#ffff00', 'Purple': '#800080', 'Orange': '#ffa500',
            'Brown': '#a52a2a', 'XS': '#f0f0f0', 'S': '#f0f0f0', 'M': '#f0f0f0',
            'L': '#f0f0f0', 'XL': '#f0f0f0', 'XXL': '#f0f0f0'
        };
        const color = colorMap[value] || '#f0f0f0';
        colorBlock.style.backgroundColor = color;
        colorBlock.style.border = (color === '#ffffff' || color === '#ffff00' || color === '#f0f0f0')
            ? '1px solid #ddd' : '1px solid transparent';
    }

    updateColorBlock(value) {
        if (!this.colorBlock) return;
        // The panel is portaled to <body> when open, so this.container no longer
        // contains the options. Query via this.panel, which travels with them.
        var scope = this.panel || this.container;
        var matchingOption = scope.querySelector('[data-value="' + value + '"] .option-color-block');
        if (matchingOption && matchingOption.style.backgroundColor) {
            this.colorBlock.style.backgroundColor = matchingOption.style.backgroundColor;
            this.colorBlock.style.border = '1px solid #ddd';
            return;
        }
        this.setColorBlock(this.colorBlock, value);
    }

    syncFromSelect() {
        if (!this.select) return;
        const selectedOption = this.select.querySelector('option:checked') ||
                               this.select.querySelector('option[selected]');
        if (selectedOption && selectedOption.value !== 'placeholder') {
            const customOption = this.container.querySelector(`[data-value="${selectedOption.value}"]`);
            if (customOption) {
                this.options.forEach(opt => opt.classList.remove('selected'));
                customOption.classList.add('selected');
                const text = customOption.querySelector('.option-text').textContent.replace(' (SOLD OUT)', '');
                this.selectedText.textContent = text;
                this.trigger.classList.remove('placeholder');
                this.updateColorBlock(selectedOption.value);
            }
        }
    }

 handleOutsideClick(e) {
    if (!this.isOpen) return;
    // Ignore taps that begin inside this dropdown's container OR its panel
    if (this.container.contains(e.target)) return;
    if (this.panel && this.panel.contains(e.target)) return;
    this.close();
}

    updateAvailability(availableValues) {
        if (this.isFirstOption && window.innerWidth < 768) return;
        this.options.forEach(option => {
            const value = option.dataset.value;
            const isAvailable = availableValues.includes(value);
            option.dataset.available = isAvailable;
            if (isAvailable) {
                option.classList.remove('disabled');
                option.querySelector('.option-text').classList.remove('sold-out');
            } else {
                option.classList.add('disabled');
                option.querySelector('.option-text').classList.add('sold-out');
            }
        });
    }
}

function initCustomDropdowns() {
    const dropdowns = document.querySelectorAll('.custom-dropdown:not(.combined-dropdown)');
    dropdowns.forEach(dropdown => new CustomDropdown(dropdown));
}

// Initialize on window load (after variant selection code runs)
window.addEventListener('load', function() {
    setTimeout(initCustomDropdowns, 700);
});

// Also initialize on Shopify section loads (for theme customizer)
document.addEventListener('shopify:section:load', initCustomDropdowns);

// =============================================================================
// Variant → Gallery sync
// When a variant is selected (either on load via ?variant= or by user click),
// jump the main gallery (and enlarged gallery, if initialised) to that
// variant's featured_image.
// =============================================================================

(function () {

  function findGalleryIndexForImageId(galleryElement, imageId) {
    // Use the original (non-cloned) cells. Flickity clones cells for wrap-around
    // and decorates them with .flickity-slider; we only want the originals.
    var cells = galleryElement.querySelectorAll('.gallery-cell:not(.is-clone-cell)');

    // Filter to cells that are NOT inside Flickity's clone wrapper.
    // The cleanest way: use Flickity's own `.cells` array if available.
    var flkty = Flickity.data(galleryElement);
    if (flkty && flkty.cells && flkty.cells.length) {
      for (var i = 0; i < flkty.cells.length; i++) {
        var el = flkty.cells[i].element;
        if (el && el.getAttribute('data-image-id') === String(imageId)) {
          return i;
        }
      }
      return -1;
    }

    // Fallback: descendant selector (not direct child)
    for (var j = 0; j < cells.length; j++) {
      if (cells[j].getAttribute('data-image-id') === String(imageId)) {
        return j;
      }
    }
    return -1;
  }

  function syncGalleryToVariant(variant) {
    console.log('syncGalleryToVariant called with:', variant);
    if (!variant || !variant.featured_image || !variant.featured_image.id) {
      console.log('Bailing: missing variant or featured_image');
      return;
    }

    var imageId = variant.featured_image.id;
    console.log('Looking for image ID:', imageId);

    // Find the main gallery element — it's a .gallery without the gallery-nav
    // or enlarged-gallery classes
    var mainGalleryEl = null;
    document.querySelectorAll('.gallery').forEach(function (el) {
      if (!el.classList.contains('gallery-nav') && !el.classList.contains('enlarged-gallery')) {
        mainGalleryEl = el;
      }
    });

    if (mainGalleryEl) {
      var mainFlkty = Flickity.data(mainGalleryEl);
      console.log('Main flickity instance:', mainFlkty);

      if (mainFlkty) {
        var idx = findGalleryIndexForImageId(mainGalleryEl, imageId);
        console.log('Index found:', idx);
        if (idx !== -1 && idx !== mainFlkty.selectedIndex % mainFlkty.cells.length) {
          mainFlkty.select(idx, false, true);
        }
      }
    }

    // Enlarged gallery (only if already initialised)
    var enlargedEl = document.querySelector('.enlarged-gallery');
    if (enlargedEl) {
      var enlargedFlkty = Flickity.data(enlargedEl);
      if (enlargedFlkty) {
        var enlargedIdx = findGalleryIndexForImageId(enlargedEl, imageId);
        if (enlargedIdx !== -1) {
          enlargedFlkty.select(enlargedIdx, false, true);
        }
      }
    }
  }

  // Listen for the form:change event that the existing variant picker fires
  $(document).on('form:change', '#add-to-cart-form', function (event, selectedVariant) {
    syncGalleryToVariant(selectedVariant);
  });

  // On initial load, sync to the variant that ?variant= in the URL specifies
  window.addEventListener('load', function () {
    setTimeout(function () {
      var $form = $('#add-to-cart-form');
      if (!$form.length) return;

      var variants;
      try {
        variants = JSON.parse(decodeURIComponent($form.attr('data-variants')));
      } catch (e) {
        return;
      }

      var params = new URLSearchParams(window.location.search);
      var urlVariantId = params.get('variant');

      if (!urlVariantId) return;

      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(urlVariantId)) {
          matched = variants[i];
          break;
        }
      }

      if (matched) {
        syncGalleryToVariant(matched);
      }
    }, 800); // after Flickity + variant picker have initialised (their setTimeout is 500)
  });

})();


// =============================================================================
// COMBINED SIZE + SHAPE DROPDOWN (mobile-only, 3-option products only)
//
// Append to the END of theme.js.
//
// IMPORTANT: This module does NOT use a <select> element for the combined
// dropdown. A legacy Shopify variant-selector library
// (Shopify.linkOptionSelectors) attaches a MutationObserver to every <select>
// on the page and crashes when it encounters the combined select — which
// breaks add-to-cart entirely. We use a <div data-combined-select> instead.
//
// This means we CANNOT rely on the existing CustomDropdown class (which
// expects this.select to be a real select). The combined dropdown manages
// its own open/close/select logic here.
//
// Strictly additive: does nothing on desktop, does nothing for non-3-option
// products. Existing desktop radios, existing mobile option1 (colour)
// dropdown, and existing cascade JS are untouched.
// =============================================================================

(function () {

  function getForm() {
    return document.getElementById('add-to-cart-form');
  }

  function isThreeOptionProduct() {
    var $form = getForm();
    return $form && $form.getAttribute('data-option-count') === '3';
  }

  function getCombinedRoot() {
    return document.querySelector('.combined-dropdown');
  }

  function getCombinedStateEl() {
    return document.querySelector('[data-combined-select]');
  }

  function getCombinedValue() {
    var el = getCombinedStateEl();
    return el ? el.getAttribute('data-value') : null;
  }

  function setCombinedValue(value) {
    var el = getCombinedStateEl();
    if (el) el.setAttribute('data-value', value);
  }

  function getMobileOption2Select() {
    var $row = document.querySelector('.mobile-add-to-cart .option-values[data-index="2"]');
    return $row ? $row.querySelector('select') : null;
  }

  function getMobileOption3Select() {
    var $row = document.querySelector('.mobile-add-to-cart .option-values[data-index="3"]');
    return $row ? $row.querySelector('select') : null;
  }

  function getVariants() {
    var $form = getForm();
    if (!$form) return [];
    try {
      return JSON.parse(decodeURIComponent($form.getAttribute('data-variants')));
    } catch (e) {
      return [];
    }
  }

  function getSelectedColour() {
    var $row = document.querySelector('.mobile-add-to-cart .option-values[data-index="1"]');
    if ($row) {
      var $sel = $row.querySelector('select');
      if ($sel && $sel.value && $sel.value !== 'placeholder') return $sel.value;
    }
    var $checked = document.querySelector('.desktop-add-to-cart .option-values[data-index="1"] input[type="radio"]:checked');
    return $checked ? $checked.value : null;
  }

  // ---------------------------------------------------------------------------
  // UI: open / close / select
  // ---------------------------------------------------------------------------

  function closeCombined(root) {
    var trigger = document.querySelector('[data-combined-trigger]');
    var panel = document.querySelector('[data-combined-panel]');
    var backdrop = document.querySelector('[data-combined-backdrop]');

    if (trigger) trigger.classList.remove('active');
    if (panel) panel.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');

    document.body.style.overflow = '';

    document.querySelectorAll('.mobile-add-to-cart').forEach(function (container) {
      container.style.zIndex = '';
      container.style.position = '';
    });
  }

  function openCombined(root) {
    // Close any other open custom dropdowns first
    document.querySelectorAll('.custom-dropdown .dropdown-panel.open').forEach(function (panel) {
      var otherContainer = panel.closest('.custom-dropdown');
      if (otherContainer === root) return;
      var otherBackdrop = otherContainer.querySelector('.dropdown-backdrop');
      panel.classList.remove('open');
      if (otherBackdrop) otherBackdrop.classList.remove('open');
      var otherTrigger = otherContainer.querySelector('.dropdown-trigger');
      if (otherTrigger) otherTrigger.classList.remove('active');
    });

    var trigger = root.querySelector('[data-combined-trigger]');
    var panel = root.querySelector('[data-combined-panel]');
    var backdrop = root.querySelector('[data-combined-backdrop]');

    if (trigger) trigger.classList.add('active');
    if (panel) panel.classList.add('open');
    if (backdrop) backdrop.classList.add('open');

    document.body.style.overflow = 'hidden';

    document.querySelectorAll('.mobile-add-to-cart').forEach(function (container) {
      if (!container.contains(root)) {
        container.style.zIndex = '-1';
        container.style.position = 'relative';
      }
    });
  }

function selectCombinedOption(root, optionEl) {
    if (optionEl.classList.contains('disabled')) return;

    var v2 = optionEl.getAttribute('data-option2');
    var v3 = optionEl.getAttribute('data-option3');
    var comboValue = optionEl.getAttribute('data-value');

    // Clear previous selection via the option's own parent (the panel), not
    // `root` - the PANEL PORTAL module moves the panel out to <body> while
    // open, so root-scoped lookups find nothing and the old default never clears.
    var panel = optionEl.parentNode;
    panel.querySelectorAll('[data-combined-option]').forEach(function (opt) {
      opt.classList.remove('selected');
    });
    optionEl.classList.add('selected');

    var trigger = root.querySelector('[data-combined-trigger]');
    if (trigger) {
      var triggerText = trigger.querySelector('.selected-text');
      if (triggerText) {
        triggerText.innerHTML =
          '<span class="combined-size">' + v2 + '</span> ' +
          '<span class="combined-shape">' + v3.toUpperCase() + '</span>';
      }
      trigger.classList.remove('placeholder');
    }

    setCombinedValue(comboValue);

    var colour = getSelectedColour();

    // Set the underlying controls to match, but DO NOT dispatch change events.
    // Dispatching change wakes the cascade + productForm resolvers, which fight
    // and re-resolve back to the initial (deep-linked) variant. We set state
    // quietly and commit the resolved variant ourselves instead.
    var sel2 = getMobileOption2Select();
    var sel3 = getMobileOption3Select();
    if (sel2) sel2.value = v2;
    if (sel3) sel3.value = v3;

    var $deskRow2 = $('.desktop-add-to-cart .option-values[data-index="2"]');
    $deskRow2.find('input[type="radio"]').prop('checked', false);
    $deskRow2.find('input[type="radio"][value="' + v2 + '"]').prop('checked', true);

    var $deskRow3 = $('.desktop-add-to-cart .option-values[data-index="3"]');
    $deskRow3.find('input[type="radio"]').prop('checked', false);
    $deskRow3.find('input[type="radio"][value="' + v3 + '"]').prop('checked', true);

    // Resolve the exact variant from (colour, size, shape) and commit directly.
    var variants = getVariants();
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var vt = variants[i];
      if (vt.option1 === colour && vt.option2 === v2 && vt.option3 === v3) {
        match = vt;
        break;
      }
    }

    $('#add-to-cart-form').trigger('form:change', [match]);

    setTimeout(function () {
      restoreOption1Availability();
    }, 0);

    closeCombined(root);
  }

  // ---------------------------------------------------------------------------
  // Force-restore option1 (colour) availability based on the current
  // option2 + option3 selection.
  // ---------------------------------------------------------------------------

  function restoreOption1Availability() {
    var variants = getVariants();
    var sel2 = getMobileOption2Select();
    var sel3 = getMobileOption3Select();
    if (!sel2 || !sel3) return;

    var v2 = sel2.value;
    var v3 = sel3.value;

    var availableColours = [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.available && v.option2 === v2 && v.option3 === v3) {
        if (availableColours.indexOf(v.option1) === -1) {
          availableColours.push(v.option1);
        }
      }
    }

    var $rows = $('.option-values[data-index="1"]');

    if (availableColours.length > 0) {
      $rows.find('select').css('opacity', '1');
      $rows.find('#custom-select-soldout').hide();
    }

    $rows.find('input[type="radio"]').each(function () {
      $(this).prop('disabled', availableColours.indexOf($(this).val()) === -1);
    });

    $rows.find('select option').each(function () {
      var val = $(this).val();
      if (val === 'placeholder') return;
      $(this).prop('disabled', availableColours.indexOf(val) === -1);
    });

    $rows.find('.dropdown-option').each(function () {
      var val = $(this).data('value');
      var isAvailable = availableColours.indexOf(val) !== -1;
      $(this).attr('data-available', isAvailable);
      if (isAvailable) {
        $(this).removeClass('disabled');
        $(this).find('.option-text').removeClass('sold-out');
      } else {
        $(this).addClass('disabled');
        $(this).find('.option-text').addClass('sold-out');
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Availability sync — called when colour changes (form:change fires)
  // ---------------------------------------------------------------------------

  function syncCombinedAvailability() {
    var root = getCombinedRoot();
    if (!root) return;

    var colour = getSelectedColour();
    var variants = getVariants();

    root.querySelectorAll('[data-combined-option]').forEach(function (optionEl) {
      var v2 = optionEl.getAttribute('data-option2');
      var v3 = optionEl.getAttribute('data-option3');

      var isAvailable = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.available
            && v.option1 === colour
            && v.option2 === v2
            && v.option3 === v3) {
          isAvailable = true;
          break;
        }
      }

      optionEl.setAttribute('data-available', isAvailable);
      if (isAvailable) {
        optionEl.classList.remove('disabled');
        var txt = optionEl.querySelector('.option-text');
        if (txt) txt.classList.remove('sold-out');
      } else {
        optionEl.classList.add('disabled');
        var txt2 = optionEl.querySelector('.option-text');
        if (txt2) txt2.classList.add('sold-out');
      }
    });
  }

  function syncCombinedSelectedState() {
    var root = getCombinedRoot();
    if (!root) return;

    var sel2 = getMobileOption2Select();
    var sel3 = getMobileOption3Select();
    if (!sel2 || !sel3) return;

    var v2 = sel2.value;
    var v3 = sel3.value;

    var match = root.querySelector(
      '[data-combined-option][data-option2="' + v2 + '"][data-option3="' + v3 + '"]'
    );
    if (!match) return;

    root.querySelectorAll('[data-combined-option]').forEach(function (opt) {
      opt.classList.remove('selected');
    });
    match.classList.add('selected');

var trigger = root.querySelector('[data-combined-trigger]');
if (trigger) {
  var triggerText = trigger.querySelector('.selected-text');
  if (triggerText) {
    triggerText.innerHTML =
      '<span class="combined-size">' + v2 + '</span> ' +
      '<span class="combined-shape">' + v3.toUpperCase() + '</span>';
  }
  trigger.classList.remove('placeholder');
}

    setCombinedValue(v2 + '|' + v3);
  }

  // ---------------------------------------------------------------------------
  // Wire-up
  // ---------------------------------------------------------------------------

  function initCombinedDropdown() {
    if (!isThreeOptionProduct()) return;

    var root = getCombinedRoot();
    if (!root) return;
    if (root.dataset.combinedInit === '1') return;
    root.dataset.combinedInit = '1';

    var trigger = root.querySelector('[data-combined-trigger]');
    var backdrop = root.querySelector('[data-combined-backdrop]');

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var panel = root.querySelector('[data-combined-panel]');
        if (panel && panel.classList.contains('open')) {
          closeCombined(root);
        } else {
          openCombined(root);
        }
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', function () { closeCombined(root); });
    }

    root.querySelectorAll('[data-combined-option]').forEach(function (optionEl) {
      optionEl.addEventListener('click', function (e) {
        e.stopPropagation();
        selectCombinedOption(root, optionEl);
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        var panel = root.querySelector('[data-combined-panel]');
        if (panel && panel.classList.contains('open')) closeCombined(root);
      }
    });

    // Sync when something upstream (e.g. colour change) triggers form:change
    $(document).on('form:change', '#add-to-cart-form', function () {
      setTimeout(function () {
        syncCombinedAvailability();
        syncCombinedSelectedState();
      }, 0);
    });

    // Initial state
    syncCombinedAvailability();
    syncCombinedSelectedState();
  }

  window.addEventListener('load', function () {
    setTimeout(initCombinedDropdown, 900);
  });

})();



// =============================================================================
// PANEL PORTAL — centre dropdown panels against the viewport, not a
// transformed ancestor. On open, move the panel + backdrop to <body>; on
// close, move them back to their original parent so all existing
// querySelector / reference logic keeps working untouched.
// =============================================================================

(function () {

  function portalOut(panel, backdrop) {
    if (!panel || panel.dataset.portaled === '1') return;

    // Remember home so we can put it back exactly where it was
    panel._portalHome = panel.parentNode;
    panel._portalNext = panel.nextSibling;
    document.body.appendChild(panel);
    panel.dataset.portaled = '1';

    if (backdrop && backdrop.dataset.portaled !== '1') {
      backdrop._portalHome = backdrop.parentNode;
      backdrop._portalNext = backdrop.nextSibling;
      document.body.appendChild(backdrop);
      backdrop.dataset.portaled = '1';
    }
  }

  function portalHome(panel, backdrop) {
    [panel, backdrop].forEach(function (el) {
      if (!el || el.dataset.portaled !== '1') return;
      if (el._portalHome) {
        el._portalHome.insertBefore(el, el._portalNext || null);
      }
      el.dataset.portaled = '0';
    });
  }

  // Watch every panel for the `open` class toggling, and portal accordingly.
  // This is system-agnostic: it works for both CustomDropdown and the
  // combined module, because both drive state via the `open` class.
  function watch(panel) {
    if (!panel || panel._portalWatched) return;
    panel._portalWatched = true;

    var root = panel.closest('.custom-dropdown, .combined-dropdown');
    var backdrop = root
      ? root.querySelector('.dropdown-backdrop, [data-combined-backdrop]')
      : null;

    new MutationObserver(function () {
      if (panel.classList.contains('open')) {
        portalOut(panel, backdrop);
      } else {
        portalHome(panel, backdrop);
      }
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  function initPortals() {
    document
      .querySelectorAll('.dropdown-panel, [data-combined-panel]')
      .forEach(watch);
  }

  // Run after both dropdown systems have initialised (their setTimeouts are
  // 700 and 900), so the panels exist and are wired before we observe them.
  window.addEventListener('load', function () {
    setTimeout(initPortals, 1000);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initPortals, 100);
  });

})();